// extracted by mini-css-extract-plugin
export default {"general":"Content_general__w8S+j","grid_peliculas":"Content_grid_peliculas__CYXMe","slider":"Content_slider__KBRpx","linea":"Content_linea__qrXnz"};